import React from 'react';
import { formatMessage } from '../utils/textFormatter';

interface StreamingMessageProps {
  content: string;
  isStreaming: boolean;
  error?: string;
}

const StreamingMessage: React.FC<StreamingMessageProps> = ({ 
  content, 
  isStreaming, 
  error 
}) => {
  return (
    <div className="message assistant">
      <div className="message-content">
        <span>{formatMessage(content)}</span>
        {isStreaming && <TypingCursor />}
        {error && (
          <div className="error-message text-red-500 text-sm mt-2">
            ⚠️ {error}
          </div>
        )}
      </div>
    </div>
  );
};

const TypingCursor: React.FC = () => (
  <span className="typing-cursor inline-block w-2 h-5 bg-blue-500 ml-1 animate-pulse"></span>
);

export default StreamingMessage;